export { default } from './useThrottle'
